"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GetDefaultBlockStyle_1 = __importDefault(require("DreamCoat/StyleShortcut/DefaultBlockStyles/GetDefaultBlockStyle"));
var PrepareStyles_1 = require("Project/Service/TCDCProjectConverter/PrepareStyles");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
exports.default = (function (usingFeature, savedStyleService, brandStore) {
    return function (block) {
        if ((0, FeatureFlag_1.isUsingTCDC)(usingFeature) && block.style == null) {
            var styles = savedStyleService.filterStylesByBlockType(block.type);
            block.style = (0, GetDefaultBlockStyle_1.default)(block.type, brandStore.colorsWithThemeIndex);
            (0, PrepareStyles_1.prepareStyle)(block.style, brandStore);
            if (styles && styles.length > 0) {
                savedStyleService.cloneSavedStyleToBlockAngular(block, styles[0]);
            }
        }
    };
});
